import t from "styled-components";
const o = t.div.withConfig({
  displayName: "EdidatableFormActions",
  componentId: "sc-k0lb81-0"
})(["display:flex;gap:var(--size-gap-4);position:absolute;right:var(--size-16);top:0;transform:translateY(100%);z-index:1;"]), e = t.div.withConfig({
  displayName: "EdidatableFormContent",
  componentId: "sc-k0lb81-1"
})(["color:var(--color-fg-default);height:100%;position:relative;width:100%;"]), a = t.div.withConfig({
  displayName: "EditableFormEditAction",
  componentId: "sc-k0lb81-2"
})(["align-items:center;color:var(--color-accent-primary-default);cursor:pointer;display:flex;gap:var(--size-gap-4);transition:all 0.2s ease-in-out;&:hover{text-decoration:underline;}"]), n = t.div.withConfig({
  displayName: "EdidatableForm",
  componentId: "sc-k0lb81-3"
})(["align-items:center;display:flex;justify-content:space-between;min-height:40px;position:relative;width:100%;"]), d = t.div.withConfig({
  displayName: "EditButton",
  componentId: "sc-k0lb81-4"
})(["align-items:center;color:var(--color-accent-primary-default);cursor:pointer;display:flex;gap:8px;height:24px;"]), l = t.div.withConfig({
  displayName: "EndButtons",
  componentId: "sc-k0lb81-5"
})(["align-items:center;display:flex;gap:var(--size-gap-4);"]);
export {
  n as EdidatableForm,
  o as EdidatableFormActions,
  e as EdidatableFormContent,
  d as EditButton,
  a as EditableFormEditAction,
  l as EndButtons
};
//# sourceMappingURL=style.es.js.map
